import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { CharSequence1ceii1xorfwh7 as CharSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/CharSequence.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { get_CharArrayPool2nrc6vmvck4s9 as get_CharArrayPool } from './CharArrayPool.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function getImpl($this, index) {
  return bufferForIndex($this, index)[index % ensureNotNull($this.w58_1).length | 0];
}
function copy($this, startIndex, endIndex) {
  if (startIndex === endIndex)
    return '';
  var builder = StringBuilder().ub(endIndex - startIndex | 0);
  var buffer;
  var base = startIndex - (startIndex % 2048 | 0) | 0;
  while (base < endIndex) {
    buffer = bufferForIndex($this, base);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = startIndex - base | 0;
    var innerStartIndex = Math.max(0, b);
    // Inline function 'kotlin.comparisons.minOf' call
    var a = endIndex - base | 0;
    var innerEndIndex = Math.min(a, 2048);
    var inductionVariable = innerStartIndex;
    if (inductionVariable < innerEndIndex)
      do {
        var innerIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        builder.o1(buffer[innerIndex]);
      }
       while (inductionVariable < innerEndIndex);
    base = base + 2048 | 0;
  }
  return builder;
}
var SubSequenceImplClass;
function SubSequenceImpl() {
  if (SubSequenceImplClass === VOID) {
    class $ {
      constructor($outer, start, end) {
        this.k5a_1 = $outer;
        this.h5a_1 = start;
        this.i5a_1 = end;
        this.j5a_1 = null;
      }
      a() {
        return this.i5a_1 - this.h5a_1 | 0;
      }
      b(index) {
        var withOffset = index + this.h5a_1 | 0;
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'index is negative: ' + index;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(withOffset < this.i5a_1)) {
          var message_0 = 'index (' + index + ') should be less than length (' + this.a() + ')';
          throw IllegalArgumentException().n2(toString(message_0));
        }
        return getImpl(this.k5a_1, withOffset);
      }
      c(startIndex, endIndex) {
        // Inline function 'kotlin.require' call
        if (!(startIndex >= 0)) {
          var message = 'start is negative: ' + startIndex;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(startIndex <= endIndex)) {
          var message_0 = 'start (' + startIndex + ') should be less or equal to end (' + endIndex + ')';
          throw IllegalArgumentException().n2(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!(endIndex <= (this.i5a_1 - this.h5a_1 | 0))) {
          var message_1 = 'end should be less than length (' + this.a() + ')';
          throw IllegalArgumentException().n2(toString(message_1));
        }
        if (startIndex === endIndex)
          return '';
        return new (SubSequenceImpl())(this.k5a_1, this.h5a_1 + startIndex | 0, this.h5a_1 + endIndex | 0);
      }
      toString() {
        var tmp0_elvis_lhs = this.j5a_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = toString(copy(this.k5a_1, this.h5a_1, this.i5a_1));
          this.j5a_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      equals(other) {
        if (!(!(other == null) ? isCharSequence(other) : false))
          return false;
        if (!(charSequenceLength(other) === this.a()))
          return false;
        return rangeEqualsImpl(this.k5a_1, this.h5a_1, other, 0, this.a());
      }
      hashCode() {
        var tmp0_safe_receiver = this.j5a_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
        return tmp1_elvis_lhs == null ? hashCodeImpl(this.k5a_1, this.h5a_1, this.i5a_1) : tmp1_elvis_lhs;
      }
    }
    initMetadataForClass($, 'SubSequenceImpl', VOID, VOID, [CharSequence()]);
    SubSequenceImplClass = $;
  }
  return SubSequenceImplClass;
}
function bufferForIndex($this, index) {
  var list = $this.v58_1;
  if (list == null) {
    if (index >= 2048) {
      throwSingleBuffer($this, index);
    }
    var tmp0_elvis_lhs = $this.w58_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSingleBuffer($this, index);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  return list.r2(index / ensureNotNull($this.w58_1).length | 0);
}
function throwSingleBuffer($this, index) {
  if ($this.y58_1)
    throw IllegalStateException().o('Buffer is already released');
  throw IndexOutOfBoundsException().i3('' + index + ' is not in range [0; ' + currentPosition($this) + ')');
}
function nonFullBuffer($this) {
  return $this.z58_1 === 0 ? appendNewArray($this) : ensureNotNull($this.w58_1);
}
function appendNewArray($this) {
  var newBuffer = $this.u58_1.s4m();
  var existing = $this.w58_1;
  $this.w58_1 = newBuffer;
  $this.z58_1 = newBuffer.length;
  $this.y58_1 = false;
  if (!(existing == null)) {
    var tmp0_elvis_lhs = $this.v58_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList().p2();
      $this.v58_1 = this_0;
      this_0.i2(existing);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    list.i2(newBuffer);
  }
  return newBuffer;
}
function rangeEqualsImpl($this, start, other, otherStart, length) {
  var inductionVariable = 0;
  if (inductionVariable < length)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(getImpl($this, start + i | 0) === charSequenceGet(other, otherStart + i | 0)))
        return false;
    }
     while (inductionVariable < length);
  return true;
}
function hashCodeImpl($this, start, end) {
  var hc = 0;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = imul(31, hc);
      // Inline function 'kotlin.code' call
      var this_0 = getImpl($this, i);
      hc = tmp + Char__toInt_impl_vasixd(this_0) | 0;
    }
     while (inductionVariable < end);
  return hc;
}
function currentPosition($this) {
  return ensureNotNull($this.w58_1).length - $this.z58_1 | 0;
}
var CharArrayBuilderClass;
function CharArrayBuilder() {
  if (CharArrayBuilderClass === VOID) {
    class $ {
      constructor(pool) {
        pool = pool === VOID ? get_CharArrayPool() : pool;
        this.u58_1 = pool;
        this.v58_1 = null;
        this.w58_1 = null;
        this.x58_1 = null;
        this.y58_1 = false;
        this.z58_1 = 0;
        this.a59_1 = 0;
      }
      a() {
        return this.a59_1;
      }
      b(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'index is negative: ' + index;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(index < this.a59_1)) {
          var message_0 = 'index ' + index + ' is not in range [0, ' + this.a59_1 + ')';
          throw IllegalArgumentException().n2(toString(message_0));
        }
        return getImpl(this, index);
      }
      c(startIndex, endIndex) {
        // Inline function 'kotlin.require' call
        if (!(startIndex <= endIndex)) {
          var message = 'startIndex (' + startIndex + ') should be less or equal to endIndex (' + endIndex + ')';
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(startIndex >= 0)) {
          var message_0 = 'startIndex is negative: ' + startIndex;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!(endIndex <= this.a59_1)) {
          var message_1 = 'endIndex (' + endIndex + ') is greater than length (' + this.a59_1 + ')';
          throw IllegalArgumentException().n2(toString(message_1));
        }
        return new (SubSequenceImpl())(this, startIndex, endIndex);
      }
      toString() {
        var tmp0_elvis_lhs = this.x58_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = toString(copy(this, 0, this.a59_1));
          this.x58_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      equals(other) {
        if (!(!(other == null) ? isCharSequence(other) : false))
          return false;
        if (!(this.a59_1 === charSequenceLength(other)))
          return false;
        return rangeEqualsImpl(this, 0, other, 0, this.a59_1);
      }
      hashCode() {
        var tmp0_safe_receiver = this.x58_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
        return tmp1_elvis_lhs == null ? hashCodeImpl(this, 0, this.a59_1) : tmp1_elvis_lhs;
      }
      o1(value) {
        nonFullBuffer(this)[ensureNotNull(this.w58_1).length - this.z58_1 | 0] = value;
        this.x58_1 = null;
        this.z58_1 = this.z58_1 - 1 | 0;
        this.a59_1 = this.a59_1 + 1 | 0;
        return this;
      }
      sg(value, startIndex, endIndex) {
        if (value == null)
          return this;
        var current = startIndex;
        while (current < endIndex) {
          var buffer = nonFullBuffer(this);
          var offset = buffer.length - this.z58_1 | 0;
          var tmp0 = endIndex - current | 0;
          // Inline function 'kotlin.math.min' call
          var b = this.z58_1;
          var bytesToCopy = Math.min(tmp0, b);
          var inductionVariable = 0;
          if (inductionVariable < bytesToCopy)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              buffer[offset + i | 0] = charSequenceGet(value, current + i | 0);
            }
             while (inductionVariable < bytesToCopy);
          current = current + bytesToCopy | 0;
          this.z58_1 = this.z58_1 - bytesToCopy | 0;
        }
        this.x58_1 = null;
        this.a59_1 = this.a59_1 + (endIndex - startIndex | 0) | 0;
        return this;
      }
      o2(value) {
        if (value == null)
          return this;
        return this.sg(value, 0, charSequenceLength(value));
      }
      w2l() {
        var list = this.v58_1;
        if (!(list == null)) {
          this.w58_1 = null;
          var inductionVariable = 0;
          var last = list.q2();
          if (inductionVariable < last)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.u58_1.t4m(list.r2(i));
            }
             while (inductionVariable < last);
        } else {
          var tmp0_safe_receiver = this.w58_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            this.u58_1.t4m(tmp0_safe_receiver);
          }
          this.w58_1 = null;
        }
        this.y58_1 = true;
        this.v58_1 = null;
        this.x58_1 = null;
        this.a59_1 = 0;
        this.z58_1 = 0;
      }
    }
    initMetadataForClass($, 'CharArrayBuilder', CharArrayBuilder, VOID, [CharSequence()]);
    CharArrayBuilderClass = $;
  }
  return CharArrayBuilderClass;
}
//region block: exports
export {
  CharArrayBuilder as CharArrayBuilder1n2d9vhxvtt4u,
};
//endregion

//# sourceMappingURL=CharArrayBuilder.mjs.map
